var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0C10.8866 0 11.2 0.313401 11.2 0.7V1.4H11.9C13.0598 1.4 14 2.3402 14 3.5V11.9C14 13.0598 13.0598 14 11.9 14H2.1C0.940202 14 0 13.0598 0 11.9V3.5C0 2.3402 0.940202 1.4 2.1 1.4H2.8V0.7C2.8 0.313401 3.1134 0 3.5 0C3.8866 0 4.2 0.313401 4.2 0.7V1.4H9.8V0.7C9.8 0.313401 10.1134 0 10.5 0ZM1.4 7V11.9C1.4 12.2866 1.7134 12.6 2.1 12.6H11.9C12.2866 12.6 12.6 12.2866 12.6 11.9V7H1.4ZM1.4 5.6H12.6V3.5C12.6 3.1134 12.2866 2.8 11.9 2.8H11.2V3.5C11.2 3.8866 10.8866 4.2 10.5 4.2C10.1134 4.2 9.8 3.8866 9.8 3.5V2.8H4.2V3.5C4.2 3.8866 3.8866 4.2 3.5 4.2C3.1134 4.2 2.8 3.8866 2.8 3.5V2.8H2.1C1.7134 2.8 1.4 3.1134 1.4 3.5V5.6Z",
    fill: "#01BEB2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.1b3ab9d0c74305041a0886143cd9f349.svg";
export { ForwardRef as ReactComponent };